import React, { useRef, useEffect } from 'react';
import { Line, Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const QualityChart = ({ data, chartType = 'line', height = 400 }) => {
  const chartRef = useRef(null);

  const ChartComponent = chartType === 'bar' ? Bar : Line;

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // Hide legend as it's shown separately in component
        position: 'bottom',
        labels: {
          boxWidth: 15,
          padding: 15,
          font: {
            size: 12,
            family: "'Montserrat', sans-serif",
            weight: '700'
          },
          fontColor: '#5d5a5b'
        }
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleFont: {
          size: 14
        },
        bodyFont: {
          size: 13
        },
        padding: 12
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        suggestedMax: 10,
        ticks: {
          precision: 0,
          font: {
            size: 11
          }
        },
        grid: {
          color: 'rgba(93, 90, 91, 1)',
          lineWidth: 1
        }
      },
      x: {
        ticks: {
          font: {
            size: 11,
            family: "'Montserrat', sans-serif",
            weight: 'normal'
          },
          color: '#5d5a5b', // Match Laravel's font color
          maxRotation: 45, // Rotate labels for better readability (matching Laravel)
          minRotation: 45,
          padding: 5 // Add padding for better spacing
        },
        grid: {
          color: 'rgba(93, 90, 91, 1)',
          lineWidth: 1
        }
      }
    },
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false
    }
  };

  return (
    <div style={{ height: `${height}px`, width: '100%' }}>
      <ChartComponent ref={chartRef} data={data} options={options} />
    </div>
  );
};

export default QualityChart;
